import React, { Fragment, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import useMenuRedirect from 'containers/Menu/hooks/useMenuRedirect';
import { useContentListPaginated } from './hooks/useContentListPaginated';
import Logger from 'services/logger';
//------------------------------------------------------------------------
import './style.scss';
import { FiltersContainer } from './components/FiltersContainer';
import { useWindowInfiniteScroll } from './hooks/useWindowInfiniteScroll';
import ContentCard from './components/FiltersContainer/ContentCard';
import HtmlDecode from 'utils/htmlDecode';
import { useGridContentStyle } from './hooks/useGridContentStyle';

const GridContentsView = ({isLoading}) => {
  const [orderingFetch, setOrderingFetch] = useState('200-DESC');
  const { cmsNodes } = useSelector(state => state.cvCMS);
  const { nodesSelected } = useMenuRedirect();
  const { code, app_behaviour } = nodesSelected;
  const {
    arrayOfContents,
    fetchMoreContents,
  } = useContentListPaginated({
    url: cmsNodes?.[code]?.carousels?.[0].component?.properties?.url,
    orderingFetch,
    code,
  });
  useGridContentStyle();
  useWindowInfiniteScroll(fetchMoreContents);
  const ordering =
    cmsNodes?.[`${code}`]?.carousels[0]?.component?.properties?.ordenamiento;
  const [selectedOrder, setSelectedOrder] = useState(
    HtmlDecode(ordering?.at(0).label) || '',
  );

  if (isLoading) return null;
  return (
    <div
      className="grid-contents-view"
      onScroll={e => Logger.debug('[GridContentsView] scroll', { scrollTop: e?.currentTarget?.scrollTop })}
    >
      {JSON.parse(app_behaviour || '{}')?.layout === 'filterbygenre' && (
        <Fragment>
          <FiltersContainer
            selectedOrder={selectedOrder}
            setSelectedOrder={setSelectedOrder}
            setOrderingFetch={setOrderingFetch}
            ordering={ordering}
            currentGenre={code}
          />
          <div className="grid-contents-view__content">
            {arrayOfContents?.map(content => (
              <ContentCard
                key={`content-item-${content?.id}`}
                item={content}
                ordering={selectedOrder}
              />
            ))}
          </div>
        </Fragment>
      )}
    </div>
  );
};

export default GridContentsView;
